import { apiRequest } from './client';
import type { BankAccount } from '../types/admin';

export type CreateBankAccountPayload = {
  readonly account_name: string;
  readonly iban: string;
  readonly bank_name: string;
  readonly swift_code?: string | null;
  readonly account_number?: string | null;
  readonly currency?: string;
  readonly privacy_offer?: string | null;
};

export type UpdateBankAccountPayload = {
  readonly account_name?: string;
  readonly iban?: string;
  readonly bank_name?: string;
  readonly swift_code?: string | null;
  readonly account_number?: string | null;
  readonly currency?: string;
  readonly privacy_offer?: string | null;
};

export function listBankAccounts(accessToken: string): Promise<readonly BankAccount[]> {
  return apiRequest<readonly BankAccount[]>('/admin/bank-accounts', {
    token: accessToken,
  });
}

export function createBankAccount(
  payload: CreateBankAccountPayload,
  accessToken: string,
): Promise<BankAccount> {
  return apiRequest<BankAccount>('/admin/bank-accounts', {
    method: 'POST',
    body: payload,
    token: accessToken,
  });
}

export function updateBankAccount(
  id: string,
  payload: UpdateBankAccountPayload,
  accessToken: string,
): Promise<BankAccount> {
  return apiRequest<BankAccount>(`/admin/bank-accounts/${id}`, {
    method: 'PATCH',
    body: payload,
    token: accessToken,
  });
}

export function deactivateBankAccount(id: string, accessToken: string): Promise<void> {
  return apiRequest<void>(`/admin/bank-accounts/${id}`, {
    method: 'DELETE',
    token: accessToken,
  });
}
